












import { Component, Vue } from "vue-property-decorator";

import FlexibleContentArea from "@/components/layout/FlexibleContentArea.vue";

@Component({
  components: { FlexibleContentArea },
})
export default class SiteSimpleImageArea extends Vue {}
